<template>
    <div class="container">
        <div class="d-flex align-items-center mb-1 justify-content-between p-1">
            <div class="d-flex align-items-center">
                <img height="40px" :src="require('@/assets/images/logo/logo.png')" />
                <h3 class="mb-0 ml-2"><span class="font-weight-bolder">{{$param('company.name')}}</span><span>{{ detail.CustomerEmail }}</span> - <span class="text-muted">{{ code }}</span></h3>
            </div>
            <feather-icon size="24" v-on:click="dark" :icon="`${isDark ? 'Sun' : 'Moon'}Icon`" class="mr-50 c-pointer" />
        </div>
        <b-overlay :show="loading || bankLoading || campaignLoading" opacity="1">
            <b-card v-if="noData==true">
                <h4>Herhangi bir ödeme bilgisi bulunamadı. Bu durum aşağıdaki nedenlerden kaynaklı olabilir: </h4>
                <ul>
                    <li>İlgili ödeme bağlantısı giriş yaptığınız kullanıcıya ait olmayabilir.</li>
                    <li>Ödemenin tamamı ödenmiş olabilir.</li>
                </ul>
                <button class="btn btn-success" v-if="noData==true" v-on:click="routeHomePage()">Ana Sayfaya Dön</button>
            </b-card>
            <b-card v-if="noData==false" no-body class="mb-0">
                <div class="pt-1 px-1 mb-1">
                    <vue-perfect-scrollbar>
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th class="text-nowrap w-70">Açıklama</th>
                                    <th class="text-nowrap w-10">Toplam Tutar (TL)</th>
                                    <th class="text-nowrap w-10">Ödenen Tutar (TL)</th>
                                    <th class="text-nowrap w-10">Kalan Tutar (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template>
                                    <tr>
                                        <td class="text-nowrap">{{$safe(detail,'Description') || "-"}}</td>
                                        <td class="text-nowrap bg-light-primary text-total">{{$safe(detail,'TotalAmountStr') || "-"}}</td>
                                        <td class="text-nowrap bg-light-success">{{$safe(detail,'TotalPaidPartStr') || "-"}}</td>
                                        <td class="text-nowrap bg-light-secondary">{{$safe(detail,'TotalRemainingDebtStr') || "-"}}</td>
                                    </tr>
                                </template>                                
                            </tbody>
                        </table>
                    </vue-perfect-scrollbar>
                </div>
                <!-- <vue-perfect-scrollbar class="mx-1">
                    <div class="d-flex justify-content-lg-center">
                        <ul class="list-group w-100 list-group-horizontal-md mb-1">
                            <li class="list-group-item font-weight-bolder w-100 d-flex justify-content-between p-50" v-for="c in campaigns" :key="c.Id" :class="['campaign',c.Bank].join('-')">
                                <span class="text-nowrap mr-50">{{$safe(c,'BankName')}}</span>
                                <span>{{$safe(c,'Campaign')}}</span>
                            </li>
                        </ul>
                    </div>
                </vue-perfect-scrollbar> -->
                <b-tabs pills active-nav-item-class="nav-pill-primary" class="px-1 pb-1" nav-class="bg-light p-25 custom-nav">
                    <b-tab title="Garanti" title-link-class="bank-0" v-if="checkBank(0)">
                        <garanti-form  active    :bank-value="0" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(0)"
                                        :logo="getLogo(0)"></garanti-form>
                    </b-tab>
                    <b-tab title="Ziraat Bankası" title-link-class="bank-6" v-if="checkBank(6)">
                        <ziraat-bank-form  :bank-value="6" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(6)"
                                        :logo="getLogo(6)"></ziraat-bank-form>
                    </b-tab>
                    
                    
                    <b-tab title="Yapı Kredi"   title-link-class="bank-1" v-if="checkBank(1)">
                        <yapi-kredi-form    :bank-value="1" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(1)"
                                        :logo="getLogo(1)"></yapi-kredi-form>
                    </b-tab>
                    
                    <b-tab title="İş Bankası" title-link-class="bank-2" v-if="checkBank(2)">
                        <is-bankasi-form    :bank-value="2" 
                                            :code="code" 
                                            :amount="detail.TotalRemainingDebt" 
                                            :amount-str="detail.TotalAmountStr"
                                            v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                            :can-installment="detail.CanInstallment"
                                            :installments="getBankInstallment(2)"
                                            :logo="getLogo(2)"></is-bankasi-form>
                    </b-tab>
                    <b-tab title="Akbank" title-link-class="bank-3" v-if="checkBank(3)">
                        <akbank-form    :bank-value="3" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(3)"
                                        :logo="getLogo(3)"></akbank-form>
                    </b-tab>
                    
                    <b-tab title="QNB Finansbank" title-link-class="bank-4" v-if="checkBank(4)">
                        <qnb-finansbank-form   :bank-value="4" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(4)"
                                        :logo="getLogo(4)"></qnb-finansbank-form>
                    </b-tab>
                    <!-- <b-tab title="Diğer" title-link-class="bank-5" v-if="checkBank(0)">
                        <other-form   :bank-value="5" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="false"
                                        :installments="[]"
                                        :logo="getLogo(5)"></other-form>
                    </b-tab> -->
                </b-tabs>
            </b-card>
        </b-overlay>
    </div>
</template>

<script> 
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BOverlay,BCard,BTabs,BTab, BSpinner } from 'bootstrap-vue'
import GarantiForm from './components/GarantiForm.vue';
import IsBankasiForm from './components/IsBankasiForm.vue';
import AkbankForm from './components/AkbankForm.vue';
import YapiKrediForm from './components/YapiKrediForm.vue';
import QnbFinansbankForm from './components/QnbFinansbankForm.vue';
import ZiraatBankForm from './components/ZiraatBankForm.vue';
import OtherForm from './components/OtherForm.vue';
import { BankApi } from '@/api/bank';
import { SystemParameterApi } from '@/api/system-parameter'
import { PaymentApi } from '@/api/payment'
import useAppConfig from '@core/app-config/useAppConfig'
import VCurrencyInput from '@/components/VCurrencyInput.vue';
import { NetsisApi } from '@/api/netsis';
export default {
    components:{
        BOverlay,
        BCard,
        BTabs,
        BTab,
        BSpinner,
        VuePerfectScrollbar,
        GarantiForm,
        ZiraatBankForm,
        IsBankasiForm,
        AkbankForm,
        YapiKrediForm,
        QnbFinansbankForm,
        OtherForm,
        VCurrencyInput
    },
    data(){
        return{
            banks:[],
            loading:false,
            bankLoading:false,
            campaignLoading:false,
            code:this.$route.params?.code || null,
            campaigns:[],
            currentIndex:-1,
            detail:{
                TotalAmount:null,
                TotalAmountStr:null,
                CanInstallment:null,
                CariCode:null,
                CustomerName:null,
                PaymentCode:null,
                TotalPaidPartStr:null,
                TotalPaidPart: null,
                TotalRemainingDebt: null,
                TotalRemainingDebtStr:null,
            },
            noData:false
        }
    },
    mounted(){
        this.getDetail()
        this.getBanks()
        // this.getBankInstallmentCampaign()
    },  
    methods:{
        routeHomePage(){
            this.$router.push({name:'home'})
        },
        getDetail(){
            this.loading = true
            PaymentApi.GetDetail(this.code).then(res=>{
                if(res.data.Success){
                    this.detail = res.data.Data
                    this.loading = false
                }else {
                    this.$result(res)
                    this.loading = false
                    this.noData=true
                }
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        getBankInstallmentCampaign(){
            this.campaignLoading = true
            SystemParameterApi.BankInstallmentsCampaign().then(res=>{
                this.campaigns = res.data.Data
                this.campaignLoading = false
            })
        },
        getBanks(){
            this.bankLoading = true
            BankApi.List().then(res=> {
                this.banks = res.data.Data
                this.bankLoading = false
            })
        },
        getLogo(bank){
            let bankF = this.banks.filter(c=> {
                return c.Value == bank
            })
            if(bankF[0]?.Logo.includes(bank+'.png'))
                return bankF[0]?.Logo
        },
        dark(){
            const { skin } = useAppConfig()
            skin.value = this.isDark ? 'light' : 'dark'
        },
        checkBank(bankValue){
            return this.banks.map(b=>b.Value).includes(bankValue)
        },
        getBankInstallment(bankValue){
            let bank = this.banks.find(b=>b.Value == bankValue)
            return bank?.Installments || []
        }
    },
    computed:{
        isDark(){
            const { skin } = useAppConfig()
            return skin.value === 'dark' ? true : false
        },
    }
}
</script>

<style>
.custom-nav .nav-link{
    margin: 0.25rem;
}
.custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 85%);
    background-color: #ffffff;
}

.dark-layout .custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 40%);
    background-color: #283046;
}
.nav-pill-primary.bank-0{
    background-color: rgb(31, 106, 4) !important;
    border-color: rgb(31, 106, 4) !important;
    box-shadow: 0 4px 18px -4px rgba(31, 106, 4, 0.65) !important;
}
.nav-pill-primary.bank-2{
    background-color: rgb(0, 67, 138) !important;
    border-color: rgb(0, 67, 138) !important;
    box-shadow: 0 4px 18px -4px rgba(0, 67, 138, 0.65) !important;
}
.nav-pill-primary.bank-3{
    background-color: rgb(224, 54, 42) !important;
    border-color: rgb(224, 54, 42) !important;
    box-shadow: 0 4px 18px -4px rgba(224, 54, 42, 0.65) !important;
}
.nav-pill-primary.bank-1{
    background-color: rgb(18, 75, 140) !important;
    border-color: rgb(18, 75, 140) !important;
    box-shadow: 0 4px 18px -4px rgba(18, 75, 140, 0.65) !important;
}

.campaign-0{
    color:rgba(31, 106, 4);
    background-color: rgba(31, 106, 4,0.1) !important;
}
.campaign-2{
    color:rgba(0, 67, 138);
    background-color: rgba(0, 67, 138,0.1) !important;
}
.campaign-3{
    color:rgba(224, 54, 42);
    background-color: rgba(224, 54, 42,0.1) !important;
}
.campaign-1{
    color:rgba(18, 75, 140);
    background-color: rgba(18, 75, 140,0.1) !important;
}

.text-total{
    color: var(--primary) !important;
}

.text-total-wo-tax{
    color: var(--secondary) !important;
}
.dark-layout .text-total{
    color: white !important
}

.currency-font-size{
    font-weight: bolder;
    height: 3rem !important;
    font-size: 2rem !important;
}
.bank-logo{
    max-width: 200px;
    object-fit: scale-down;
}
.card-box{
    height: calc(100% - 120px);
}
</style>